<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">Mmpi A</h3>
    </div>
</div>
<app-camera *ngIf="testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                
                <div *ngIf="texts" #instructions class="m-b-30"></div>

                <div class="col-12">
                    <button class="btn waves-effect btn-rounded btn-info mx-2 mx-2" (click)="reload()">Cancelar</button>
                    <button type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" [disabled]="!questions" (click)="startTest()" data-toggle="modal" data-target="#myModal" > Realizar test </button>

                </div>

                <!-- sample modal content -->
                <div id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title" id="myModalLabel">MMPI A</h4>

                            </div>
                            <div *ngIf="selectedQuestion" class="modal-body">
                                <p>{{index+1}}/{{questions.length}} - <b>{{selectedQuestion.text}}</b></p>
                                <div class="col">
                                    <a href="javascript:void(0)" class="btn btn-block btn-lg btn-info" style="font-size: 15px;" (click)="select(true)" >Verdadero</a>
                                    <br>
                                </div>
                                <div class="col">
                                    <a href="javascript:void(0)" class="btn btn-block btn-lg btn-info" style="font-size: 15px;" (click)="select(false)" >Falso</a>
                                    <br>
                                </div>
                                <div class="col">
                                    <a href="javascript:void(0)" class="btn btn-block btn-lg btn-info" style="font-size: 15px;" (click)="select(undefined)" >No sé</a>
                                    <br>
                                </div>


                            </div>

                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                </div>
                <!-- /.modal -->
            </div>
        </div>
    </div>
</div>